import React, { useState } from "react";
import "./ProductoBuscador.css";
import iconoBuscar from "../../../../../assets/img/icons/busqueda.svg"; // ajusta tu ruta
import SubTituloModulo from "../../../../componentsUI/estructura/tituloModulos/tituloSubModulo.js";


export default function ProductoBuscador({ placeholder = "Buscar...", onBuscar }) {
  const [termino, setTermino] = useState("");

  const handleChange = (e) => {
    const valor = e.target.value;
    setTermino(valor);
    // Si se pasa una función de búsqueda, la ejecuta
    if (onBuscar) onBuscar(valor);
  };

  return (
    
<div className="busqueda-wrapper">
  <SubTituloModulo subtitulo="Buscar productos" />

  <div className="barra-busqueda">
    <img src={iconoBuscar} alt="buscar" className="icono-buscar" />
    <input
      type="text"
      value={termino}
      onChange={handleChange}
      placeholder={placeholder}
      className="input-busqueda"
    />
  </div>
</div>
  );
}